export const DEFAULT_UI_DELAY = 3000;
export const PREVENT_UI_DELAY = -1;
export const VOLUME_STEP = 10;
export const VOLUME_MIN = 0;
export const VOLUME_MAX = 100;
